import React from 'react';
import OECDExplorer from './components/OECDExplorer';
import './App.css';

function App() {
  return (
    <div className="App">
      <OECDExplorer />
    </div>
  );
}

export default App;